module.exports = __webpack_public_path__ + "img/P1.920562a4.png";